import { customBeginCompletion } from "./environments.js";
import { documentEnvironments } from "../document-environments.js";
/**
 * Environments from the current doc
 */
export function customEnvironmentCompletions(context) {
    const items = findEnvironmentsInDoc(context);
    const completions = [];
    for (const env of items.values()) {
        const completion = customBeginCompletion(env);
        if (completion) {
            completions.push(completion);
        }
    }
    return completions;
}
export const findEnvironmentsInDoc = (context) => {
    const result = new Set();
    const environmentNamesProjection = context.state.field(documentEnvironments);
    if (!environmentNamesProjection || !environmentNamesProjection.items) {
        return result;
    }
    for (const environment of environmentNamesProjection.items) {
        // include the environment name if it's outside the current context
        if (environment.to < context.pos || environment.from > context.pos) {
            result.add(environment.title);
        }
    }
    return result;
};
